import { createPortal } from 'react-dom';
import { CheckCircle2, XCircle, Info, X } from 'lucide-react';
import { useUiStore, type ToastKind } from '../../store/uiStore';

const icons: Record<ToastKind, typeof CheckCircle2> = {
  success: CheckCircle2,
  error: XCircle,
  info: Info,
};

const tones: Record<ToastKind, string> = {
  success: 'text-success',
  error: 'text-danger',
  info: 'text-navy',
};

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  return createPortal(
    <div aria-live="polite" aria-relevant="additions" className="studio-portal studio-toasts fixed bottom-5 right-5 z-[100] flex w-80 max-w-[calc(100vw-40px)] flex-col gap-2">
      {toasts.map((t) => {
        const Icon = icons[t.kind];
        return (
          <div
            key={t.id}
            className="flex animate-fade-in items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 shadow-panel"
          >
            <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${tones[t.kind]}`} />
            <p className="flex-1 text-sm text-ink">{t.message}</p>
            <button onClick={() => dismiss(t.id)} className="text-slate hover:text-ink" aria-label="Fechar">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>,
    document.body,
  );
}
